import { useEffect, useState } from 'react';
import DriverLayout from '../../layouts/DriverLayout'
import DriverService from '../../services/DriverService';
import { useNavigate, useParams } from "react-router-dom";
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Grid,
    Input,
    Select,
    Heading, useToast
} from "@chakra-ui/react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
    VMake: Yup.string().required("Make is required"),
    VModel: Yup.string().required("Model is required"),
    VNo: Yup.string().required("Vehicle No is required"),
    VEngNo: Yup.string().required("Engine No is required"),
    VRegNo: Yup.string().required("Reg No is required"),
    VRegDt: Yup.string().required("Reg Date is required"),
    VRegEndDt: Yup.string().required("Reg End Date is required"),
    VInsNo: Yup.string().required("Insurance No is required"),
    VInsCompany: Yup.string().required("Insurance Company is required"),
    VInsEndDt: Yup.string().required("Insurance End Date is required"),
    VColor: Yup.string().required("Color is required"),
    VTyp: Yup.string().required("Type is required"),
});

const DriverVehicle = () => {

    const user = JSON.parse(localStorage.getItem("user"));
    const toast = useToast();
    const [vehicleDetails, setVehicleDetails] = useState();
    const adminApproved = vehicleDetails?.Stat == 5 // Admin have taken action.

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const navigate = useNavigate();
    const { DVNo } = useParams();

    useEffect(() => {

        vehicleDetail();
    }, []);

    const vehicleDetail = async () => {
        let params = {
            uId: user.uId,
            DVNo: Number(DVNo)
        }
        try {
            const res = await DriverService.getVehicleDetail(params);
            if (res.statusCode === 200) {
                const vals = res.data;
                // Set form values
                setValue("VMake", vals.VMake);
                setValue("VModel", vals.VModel);
                setValue("VNo", vals.VNo);
                setValue("VEngNo", vals.VEngNo);
                setValue("VRegNo", vals.VRegNo);
                setValue("VRegDt", vals.VRegDt?.substring(0, 10)); // "yyyy-mm-dd"
                setValue("VRegEndDt", vals.VRegEndDt?.substring(0, 10));
                setValue("VInsNo", vals.VInsNo);
                setValue("VInsCompany", vals.VInsCompany);
                setValue("VInsEndDt", vals.VInsEndDt?.substring(0, 10));
                setValue("VColor", vals.VColor);
                setValue("VTyp", vals.VTyp?.toString());
                setVehicleDetails(vals)
            }
        } catch (error) {
            if (error.response?.status === 401) {
                toast({
                    title: 'Error',
                    description: error.response.data.message,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
            } else {
                toast({
                    title: 'Error',
                    description: 'Something went wrong. Please try again.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
                console.error(error);
            }
        }
    };

    const handleVehicle = async (data) => {

        const {
            vehiclePic,
            registrationPic,
            enginePic,
            insurancePic,
        } = watch();

        const formDt = new FormData();
        formDt.append("VColor", data.VColor);
        formDt.append("VEngNo", data.VEngNo);
        formDt.append("VInsCompany", data.VInsCompany);
        formDt.append("VInsEndDt", data.VInsEndDt);
        formDt.append("VInsNo", data.VInsNo);
        formDt.append("VMake", data.VMake);
        formDt.append("VModel", data.VModel);
        formDt.append("VNo", data.VNo);
        formDt.append("VRegDt", data.VRegDt);
        formDt.append("VRegEndDt", data.VRegEndDt);
        formDt.append("VRegNo", data.VRegNo);
        formDt.append("VTyp", data.VTyp);
        formDt.append("uId", user.uId);
        formDt.append("DVNo", Number(DVNo));

        if (vehiclePic) formDt.append("vehiclePic", vehiclePic);
        if (registrationPic) formDt.append("registrationPic", registrationPic);
        if (enginePic) formDt.append("enginePic", enginePic);
        if (insurancePic) formDt.append("insurancePic", insurancePic);

        try {
            const res = await DriverService.saveVehicle(formDt);
            if (res.statusCode === 200) {
                toast({
                    title: 'Vehicle',
                    description: res.message,
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
                navigate('/driver/vehicle')
            }
        } catch (error) {
            if (error.response?.status === 401) {
                toast({
                    title: 'Error',
                    description: error.response.data.message,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
            } else {
                toast({
                    title: 'Error',
                    description: "Something went wrong. Please try again.",
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
                console.error(error);
            }
        }

    }

    return (
        <DriverLayout>
            <Box maxW="1000px" mx="auto" px={4} >
                <Box maxW="900px" mx="auto" mt={2}>
                    <Box bg="blue.500" color="white" py={3} px={6} borderTopRadius="lg">
                        <Heading size="sm">Edit Vehicle</Heading>
                    </Box>
                    <Box
                        bg="white"
                        p={6}
                        roundedBottom="xl"
                        boxShadow="md"
                        border="1px solid"
                        borderColor="gray.200"
                    >
                        <form onSubmit={handleSubmit(handleVehicle)}>
                            <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={3}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Make (Company)</FormLabel>
                                    <Input type="text" {...register("VMake")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VMake?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Model Name</FormLabel>
                                    <Input type="text" {...register("VModel")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VModel?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Vehicle No</FormLabel>
                                    <Input type="text" {...register("VNo")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VNo?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Engine No</FormLabel>
                                    <Input type="text" {...register("VEngNo")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VEngNo?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Registration No</FormLabel>
                                    <Input type="text" {...register("VRegNo")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VRegNo?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Registration Date</FormLabel>
                                    <Input type="date" {...register("VRegDt")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VRegDt?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Registration End Date</FormLabel>
                                    <Input type="date" {...register("VRegEndDt")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VRegEndDt?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Insurance No</FormLabel>
                                    <Input type="text" {...register("VInsNo")} size="sm" />
                                    <Box color="red.500" fontSize="xs">{errors.VInsNo?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Insurance Company</FormLabel>
                                    <Input type="text" {...register("VInsCompany")} size="sm" />
                                    <Box color="red.500" fontSize="xs">{errors.VInsCompany?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Insurance End Date</FormLabel>
                                    <Input type="date" {...register("VInsEndDt")} size="sm" />
                                    <Box color="red.500" fontSize="xs">{errors.VInsEndDt?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Color</FormLabel>
                                    <Input type="text" {...register("VColor")} size="sm" disabled={adminApproved} />
                                    <Box color="red.500" fontSize="xs">{errors.VColor?.message}</Box>
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Type</FormLabel>
                                    <Select {...register("VTyp")} size="sm" disabled={adminApproved}>
                                        <option value="">Select</option>
                                        <option value="2">2-Wheeler</option>
                                        <option value="4">4-Passenger</option>
                                        <option value="5">5-Passenger</option>
                                        <option value="7">7-Passenger</option>
                                    </Select>
                                    <Box color="red.500" fontSize="xs">{errors.VTyp?.message}</Box>
                                </FormControl>

                                <FormControl >
                                    <FormLabel fontSize="sm">Vehicle Pic</FormLabel>
                                    <Input
                                        type="file"
                                        onChange={(e) => setValue("vehiclePic", e.target.files[0])}
                                        size='sm'
                                        disabled={adminApproved}
                                    />
                                </FormControl>

                                <FormControl >
                                    <FormLabel fontSize="sm">Registration Pic</FormLabel>
                                    <Input
                                        type="file"
                                        onChange={(e) => setValue("registrationPic", e.target.files[0])}
                                        size='sm'
                                        disabled={adminApproved}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel fontSize="sm">Engine Pic</FormLabel>
                                    <Input
                                        type="file"
                                        onChange={(e) => setValue("enginePic", e.target.files[0])}
                                        size='sm'
                                        disabled={adminApproved}
                                    />
                                </FormControl>

                                <FormControl >
                                    <FormLabel fontSize="sm">Insurance Pic</FormLabel>
                                    <Input
                                        type="file"
                                        onChange={(e) => setValue("insurancePic", e.target.files[0])}
                                        size='sm'
                                    />
                                </FormControl>

                            </Grid>
                            <Box textAlign="center" pt={4}>
                                <Button
                                    type="submit"
                                    size="md"
                                    bg="#62a13b"
                                    color="white"
                                    _hover={{ bg: "#538d32" }}
                                    boxShadow="lg"
                                    px={10}
                                    py={2}
                                    borderRadius="full"
                                    fontWeight="bold"
                                >
                                    Update
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </Box>
            </Box>
        </DriverLayout>
    )
}

export default DriverVehicle
